export const limitedReleaseBySNConstants = {
  LIMITED_RELEASE_BY_SN_LOADING: "LIMITED_RELEASE_BY_SN_LOADING",
  LIMITED_RELEASE_BY_SN_SUCCESS: "LIMITED_RELEASE_BY_SN_SUCCESS",
  LIMITED_RELEASE_BY_SN_FAILURE: "LIMITED_RELEASE_BY_SN_FAILURE",
};

export const createLimitedReleaseBySNConstants = {
  CREATE_LIMITED_RELEASE_BY_SN_LOADING: "CREATE_LIMITED_RELEASE_BY_SN_LOADING",
  CREATE_LIMITED_RELEASE_BY_SN_SUCCESS: "CREATE_LIMITED_RELEASE_BY_SN_SUCCESS",
  CREATE_LIMITED_RELEASE_BY_SN_FAILURE: "CREATE_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const editLimitedReleaseBySNConstants = {
  EDIT_LIMITED_RELEASE_BY_SN_LOADING: "EDIT_LIMITED_RELEASE_BY_SN_LOADING",
  EDIT_LIMITED_RELEASE_BY_SN_SUCCESS: "EDIT_LIMITED_RELEASE_BY_SN_SUCCESS",
  EDIT_LIMITED_RELEASE_BY_SN_FAILURE: "EDIT_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const deleteLimitedReleaseBySNConstants = {
  DELETE_LIMITED_RELEASE_BY_SN_LOADING: "DELETE_LIMITED_RELEASE_BY_SN_LOADING",
  DELETE_LIMITED_RELEASE_BY_SN_SUCCESS: "DELETE_LIMITED_RELEASE_BY_SN_SUCCESS",
  DELETE_LIMITED_RELEASE_BY_SN_FAILURE: "DELETE_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const addTargetLimitedReleaseBySNConstants = {
  ADD_TARGET_LIMITED_RELEASE_BY_SN_LOADING:
    "ADD_TARGET_LIMITED_RELEASE_BY_SN_LOADING",
  ADD_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS:
    "ADD_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS",
  ADD_TARGET_LIMITED_RELEASE_BY_SN_FAILURE:
    "ADD_TARGET_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const removeTargetLimitedReleaseBySNConstants = {
  REMOVE_TARGET_LIMITED_RELEASE_BY_SN_LOADING:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_SN_LOADING",
  REMOVE_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_SN_SUCCESS",
  REMOVE_TARGET_LIMITED_RELEASE_BY_SN_FAILURE:
    "REMOVE_TARGET_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const activateLimitedReleaseBySNConstants = {
  ACTIVATE_LIMITED_RELEASE_BY_SN_LOADING:
    "ACTIVATE_LIMITED_RELEASE_BY_SN_LOADING",
  ACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS:
    "ACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS",
  ACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE:
    "ACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE",
};

export const deactivateLimitedReleaseBySNConstants = {
  DEACTIVATE_LIMITED_RELEASE_BY_SN_LOADING:
    "DEACTIVATE_LIMITED_RELEASE_BY_SN_LOADING",
  DEACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS:
    "DEACTIVATE_LIMITED_RELEASE_BY_SN_SUCCESS",
  DEACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE:
    "DEACTIVATE_LIMITED_RELEASE_BY_SN_FAILURE",
};
